import { NgModule  } from '@angular/core';

import { CustomerPaymentActionsComponent } from './customer-payment.actions.component';
import { SharedModule }                    from '../../../app-lite/shared/shared.module';

@NgModule({
    declarations : [
        CustomerPaymentActionsComponent
    ],
    entryComponents: [
        CustomerPaymentActionsComponent
    ],
    imports: [
        SharedModule
    ]
})
export class CustomerPaymentsModule {}